module.exports = __webpack_public_path__ + "static/media/ico-team.2938aac3.svg";